<app-header sectionName="Accounting"></app-header>

<div class="page">
  <nav mat-tab-nav-bar [tabPanel]="panel" class="tabs">
    <a mat-tab-link [active]="tab === 'export'" (click)="tab = 'export'">
      <mat-icon class="tab-icon">cloud_upload</mat-icon> Export to Hesabfa
    </a>
    <a mat-tab-link [active]="tab === 'compare'" (click)="tab = 'compare'">
      <mat-icon class="tab-icon">compare_arrows</mat-icon> Compare with Hesabfa
    </a>
  </nav>

  <mat-tab-nav-panel #panel>
  @if (tab === 'export') {
  <section class="list-toolbar">
    <mat-form-field appearance="outline" class="f-date" subscriptSizing="dynamic">
      <mat-label>From</mat-label>
      <input matInput type="date" [(ngModel)]="exportFrom" [attr.max]="exportTo || null">
    </mat-form-field>
    <mat-form-field appearance="outline" class="f-date" subscriptSizing="dynamic">
      <mat-label>To</mat-label>
      <input matInput type="date" [(ngModel)]="exportTo" [attr.min]="exportFrom || null">
    </mat-form-field>
    @if (canEdit) {
    <button mat-flat-button color="primary" type="button" [disabled]="starting || running" (click)="startExport()">
      @if (starting) { <mat-spinner diameter="18"></mat-spinner> } @else { <mat-icon>cloud_upload</mat-icon> }
      Export these days
    </button>
    }
    <span class="spacer"></span>
    <button mat-icon-button type="button" matTooltip="Refresh" (click)="loadExports()"><mat-icon>refresh</mat-icon></button>
  </section>
  <p class="explain">
    <mat-icon>info</mat-icon>
    Each settlement paid on these days (Tehran time) becomes a purchase invoice with its payment, from the account recorded as paid-from.
    Exporting a day again only adds what is missing; invoices the accountant entered by hand are recognised and left alone.
  </p>

  <div class="table-card">
    @if (exportsLoading) {
    <div class="table-state"><mat-spinner diameter="28"></mat-spinner></div>
    } @else if (exports.length === 0) {
    <div class="table-state">No exports yet.</div>
    } @else {
    <div class="runs">
      @for (e of exports; track e.id) {
      <div class="run">
        <div class="run-head" (click)="toggle(e)">
          <span class="chip" [ngClass]="'run-' + e.status.toLowerCase()">{{ e.status }}</span>
          <span class="run-days">{{ e.from === e.to ? e.from : e.from + ' → ' + e.to }}</span>
          <span class="run-meta">{{ e.created_at | date:'short' }}@if (e.created_by) { · {{ e.created_by }} }</span>
          <span class="spacer"></span>
          <span class="run-stats">
            <span matTooltip="Settlements on these days">{{ e.settlements }} settlements</span>
            <span matTooltip="Invoices sent">· {{ e.invoices_created }} invoices</span>
            <span matTooltip="Payments recorded">· {{ e.payments_created }} payments</span>
            @if (e.contacts_created) { <span matTooltip="New contacts">· {{ e.contacts_created }} contacts</span> }
            @if (e.already_exported) { <span matTooltip="Already in Hesabfa from an earlier export">· {{ e.already_exported }} already there</span> }
            @if (e.skipped) { <span class="warn" matTooltip="Entered by hand in Hesabfa; not sent">· {{ e.skipped }} by hand</span> }
            @if (e.failed) { <span class="err">· {{ e.failed }} failed</span> }
          </span>
          @if (e.issues.length || e.error) {
          <mat-icon class="expand">{{ expanded.has(e.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
          }
          @if (e.status === 'Done' || e.status === 'Failed') {
          <button mat-button type="button" (click)="$event.stopPropagation(); compareRun(e)">
            <mat-icon>compare_arrows</mat-icon> Compare
          </button>
          }
        </div>
        @if (expanded.has(e.id)) {
        @if (e.error) { <p class="run-error"><mat-icon>error</mat-icon> {{ e.error }}</p> }
        @if (e.issues.length) {
        <ul class="issues">
          @for (i of e.issues; track $index) {
          <li><code>{{ i.settlement_id.slice(0, 8) }}</code> <bdi>{{ i.error }}</bdi></li>
          }
        </ul>
        }
        }
      </div>
      }
    </div>
    }
  </div>
  }

  @if (tab === 'compare') {
  <section class="list-toolbar">
    <mat-form-field appearance="outline" class="f-date" subscriptSizing="dynamic">
      <mat-label>From</mat-label>
      <input matInput type="date" [(ngModel)]="compareFrom" [attr.max]="compareTo || null">
    </mat-form-field>
    <mat-form-field appearance="outline" class="f-date" subscriptSizing="dynamic">
      <mat-label>To</mat-label>
      <input matInput type="date" [(ngModel)]="compareTo" [attr.min]="compareFrom || null">
    </mat-form-field>
    <button mat-flat-button color="primary" type="button" [disabled]="comparing" (click)="compare()">
      @if (comparing) { <mat-spinner diameter="18"></mat-spinner> } @else { <mat-icon>compare_arrows</mat-icon> }
      Compare
    </button>
    <mat-slide-toggle [(ngModel)]="onlyProblems">Only differences</mat-slide-toggle>
  </section>

  @if (compareError) { <p class="run-error"><mat-icon>error</mat-icon> {{ compareError }}</p> }

  @if (comparison) {
  <div class="summary">
    <span class="sum-item">{{ comparison.counts['rows'] || 0 }} rows</span>
    <span class="sum-item ok"><mat-icon>check_circle</mat-icon> {{ comparison.counts['ok'] || 0 }} match</span>
    @for (c of issueCounts; track c.issue) {
    <button type="button" class="issue-chip" [class.active]="issueFilter === c.issue" (click)="filterBy(c.issue)">
      {{ issueLabels[c.issue] }} <b>{{ c.count }}</b>
    </button>
    }
  </div>

  <div class="table-card">
    @if (rows.length === 0) {
    <div class="table-state">{{ onlyProblems ? 'No differences on these days.' : 'Nothing on these days.' }}</div>
    } @else {
    <div class="table-scroll">
      <table class="cmp">
        <thead>
          <tr>
            <th>Day</th>
            <th>In the bot</th>
            <th>In Hesabfa</th>
            <th>Differences</th>
          </tr>
        </thead>
        <tbody>
          @for (r of rows; track $index) {
          <tr>
            <td class="day">
              {{ r.bot?.day || r.hesabfa?.day }}
              <div class="sub">{{ matchLabels[r.match] }}</div>
            </td>
            <td>
              @if (r.bot; as b) {
              <div class="side">
                <bdi class="strong" [class.diff]="differs(r, 'contact')">{{ b.contact }}</bdi>
                @if (b.settlements[0].supplier_name !== b.contact) { <span class="sub">supplier <bdi>{{ b.settlements[0].supplier_name }}</bdi></span> }
                <span [class.diff]="differs(r, 'amount')">{{ b.amount_rial | number }} Rial</span>
                @if (b.coins) { <span class="sub" [class.diff]="differs(r, 'coins')">{{ b.coins | number }} coins</span> }
                <span class="sub">
                  @if (b.settlements.length > 1) { {{ b.settlements.length }} settlements · }
                  @for (s of b.settlements; track s.id) { <code>{{ s.id.slice(0, 8) }}</code> }
                  @if (b.settlements[0].kind !== 'Payout') { · {{ b.settlements[0].kind }} }
                </span>
                <span class="sub" [class.diff]="differs(r, 'payment_source') || differs(r, 'no_source') || differs(r, 'source_unresolved')">
                  paid from: @if (b.source) { <bdi>{{ b.source }}</bdi> <code>{{ b.source_code }}</code>@if (b.source_unspecified) { (unspecified) } } @else { not recorded }
                  @if (b.fee_rial) { · fee {{ b.fee_rial | number }} }
                </span>
                @if (canEdit && missingSource(r)) {
                <button mat-stroked-button type="button" class="fix" (click)="setSource(r)">
                  <mat-icon>account_balance</mat-icon> Set paid-from
                </button>
                }
              </div>
              } @else { <span class="muted">—</span> }
            </td>
            <td>
              @if (r.hesabfa; as h) {
              <div class="side">
                <span class="strong">#{{ h.invoice_number }}</span>
                <bdi [class.diff]="differs(r, 'contact')">{{ h.contact }} <code>{{ h.contact_code }}</code></bdi>
                <span [class.diff]="differs(r, 'amount')">{{ h.amount_rial | number }} Rial</span>
                @if (h.coins) { <span class="sub" [class.diff]="differs(r, 'coins')">{{ h.coins | number }} coins</span> }
                @if (r.hesabfa.day !== r.bot?.day && r.bot) { <span class="sub diff">dated {{ h.day }}</span> }
                @for (p of h.payments; track p.number) {
                <span class="sub" [class.diff]="differs(r, 'payment_source') || differs(r, 'payment_amount') || differs(r, 'payment_fee')">
                  <mat-icon class="tiny" [matTooltip]="p.linked ? 'Recorded against the invoice' : 'A separate payment, not linked to the invoice'">
                    {{ p.linked ? 'link' : 'link_off' }}
                  </mat-icon>
                  paid {{ p.amount_rial | number }} from <bdi>{{ p.source }}</bdi> <code>{{ p.source_code }}</code>
                  @if (p.fee_rial) { · fee {{ p.fee_rial | number }} }
                </span>
                } @empty {
                @if (h.paid_rial) { <span class="sub">paid {{ h.paid_rial | number }}</span> }
                @else { <span class="sub" [class.diff]="differs(r, 'payment_missing')">no payment</span> }
                }
              </div>
              } @else { <span class="muted">—</span> }
            </td>
            <td>
              @if (r.issues.length === 0) {
              <span class="ok"><mat-icon>check_circle</mat-icon></span>
              }
              <div class="issue-list">
                @for (i of r.issues; track i) { <span class="issue">{{ issueLabels[i] }}</span> }
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
  }
  }
  </mat-tab-nav-panel>
</div>
